import { toastStore } from 'shared/ui'
import { IS_APP_LIGHT } from 'shared/config'
import { PaygLimitModalStore } from 'entities/Subscription/ui/PaygLimitModal'
import { TrialLimitModalStore } from 'entities/Subscription/ui/TrialLimitModal'
import { TwilioNumberSelectionModalStore } from 'entities/Subscription/ui/TwilioNumberSelectionModal'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { GoToQuestionnaireModalStore } from 'pages/settings/pages/compliance/ui/GoToQuestionnaireModal'
import { CANCELED_SUBSCRIPTION_TOAST } from 'pages/settings/lib/canceledSubscriptionToast'

function shouldOpenTwilioNumberSelectionModal(entities: IEntitiesStore): boolean {
  return (
    entities.organizationStore.isTwilioNumberVendor &&
    Boolean(entities.usersStore.user?.isRequireNumber) &&
    !entities.subscriptionStore.isAgencyWithoutSubscription &&
    !entities.numbersStore.hasTwilioIntegrationNumbers
  )
}

function shouldOpenQuestionnaire(entities: IEntitiesStore): boolean {
  const isRestricted = entities.subscriptionStore.isTrial || entities.subscriptionStore.isPAYGPlan

  if (entities.usersStore.user?.isUKCountry) return false

  return (
    isRestricted &&
    !entities.organizationStore.isTwilioNumberVendor &&
    Boolean(entities.usersStore.user?.isRequireNumber) &&
    !entities.numbersStore.hasTwilioIntegrationNumbers
  )
}

function shouldOpenTrialLimitModal(entities: IEntitiesStore): boolean {
  return (
    entities.subscriptionStore.isTrial &&
    !entities.usersStore.user?.isRequireNumber &&
    !entities.numbersStore.hasTwilioIntegrationNumbers
  )
}

function shouldOpenPaygLimitModal(entities: IEntitiesStore): boolean {
  return (
    entities.subscriptionStore.isPAYGPlan &&
    !entities.organizationStore.isTwilioNumberVendor &&
    !entities.usersStore.user?.isRequireNumber
  )
}

type IRunBeforeAddNumberOptions = {
  checkCanceled?: boolean
}

export function runBeforeAddNumber(
  entities: IEntitiesStore,
  onProceed: () => void,
  options: IRunBeforeAddNumberOptions = {}
): void {
  const { checkCanceled = true } = options

  if (checkCanceled && entities.subscriptionStore.isCanceled) {
    toastStore.add(CANCELED_SUBSCRIPTION_TOAST)
    return
  }

  if (shouldOpenTwilioNumberSelectionModal(entities) && !IS_APP_LIGHT) {
    new TwilioNumberSelectionModalStore(entities).open()
    return
  }

  if (shouldOpenQuestionnaire(entities)) {
    new GoToQuestionnaireModalStore(entities).open('numbers')
    return
  }

  if (shouldOpenTrialLimitModal(entities)) {
    new TrialLimitModalStore(entities).open('numbers')
    return
  }

  if (shouldOpenPaygLimitModal(entities)) {
    new PaygLimitModalStore(entities).open('numbers')
    return
  }

  onProceed()
}
